/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1PersonIdAddressesCopyToPaymentMutationResponse,
  PostApiV1PersonIdAddressesCopyToPaymentPathParams,
  PostApiV1PersonIdAddressesCopyToPayment401,
  PostApiV1PersonIdAddressesCopyToPayment404,
  PostApiV1PersonIdAddressesCopyToPayment500,
} from "../../types/personRegisterController/PostApiV1PersonIdAddressesCopyToPayment.ts";

function getPostApiV1PersonIdAddressesCopyToPaymentUrl(
  id: PostApiV1PersonIdAddressesCopyToPaymentPathParams["id"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/person/${id}/addresses/copy-to-payment` as const,
  };
  return res;
}

/**
 * @description Copia o endereço pessoal da pessoa para o endereço de pagamento (cria ou atualiza). **(Requer Authorization para autenticação)**
 * @summary Copiar endereço pessoal para pagamento (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/addresses/copy-to-payment}
 */
export async function postApiV1PersonIdAddressesCopyToPayment(
  id: PostApiV1PersonIdAddressesCopyToPaymentPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiV1PersonIdAddressesCopyToPaymentMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PersonIdAddressesCopyToPayment401
      | PostApiV1PersonIdAddressesCopyToPayment404
      | PostApiV1PersonIdAddressesCopyToPayment500
    >,
    unknown
  >({
    method: "POST",
    url: getPostApiV1PersonIdAddressesCopyToPaymentUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
